import {Component, Input, OnInit} from "@angular/core";
import { GroupDescriptor, GroupResult } from '@progress/kendo-data-query';
import {GiiAtaskaitaApi} from '../../api/gii-ataskaita.api';
import {KlasifikatoriusApi} from "../../api/klasifikatorius.api";
import {AtaskVeiklosDuomenysApi} from '../../api/atask-veiklos-duomenys.api';
import {TranslateService} from '@ngx-translate/core';
import {GiiRegistracijaApi} from '../../api/gii-registracija.api';
import {GiiAtaskVertinimasApi} from '../../api/gii-atask-vertinimas.api';
import {SharedDataService} from "../../service/shared-data.service";
import {LanguageService} from "../../service/language.service";

@Component({
  selector: "atask-perziura",
  template: `
    <div>
      <div class="content mb-3">
        <div class="row">
          <div class="col-4">
            <div class="row mb-2">
              <label class="label">
                <u>
                  {{ 'apskaita.title.bendriDuomenys' | translate }}
                </u>
              </label>
            </div>
            <div class="row">
              <label class="label">
                {{ 'apskaita.dokumentoTipas' | translate }}
              </label>
              <div>{{ 'enum.dokumentoTipas.' + data.dokumentoTipas | translate }}</div>
            </div>
            <div class="row">
              <label class="label">
                {{ 'apskaita.ataskLaikotarpis' | translate }}
              </label>
              <div>{{ data.ataskLaikotarpis }}</div>
            </div>
            <div class="row">
              <label class="label">
                {{ 'apskaita.busena' | translate }}
              </label>
              <div>{{ 'enum.ataskaitosBusena.' + data.busena | translate }}</div>
            </div>
            <div class="row">
              <label class="label">
                {{ 'apskaita.busenosData' | translate }}
              </label>
              <div>{{ data.busenosData | date: 'yyyy-MM-dd' }}</div>
            </div>
          </div>
          <div class="col-5">
            <div class="row mb-2">
              <label class="label">
                <u>
                  {{ 'apskaita.title.giisRegistracija' | translate }}
                </u>
              </label>
            </div>
            <div class="row">
              <label class="label">
                {{ 'apskaita.subjektas' | translate }}
              </label>
              <div>{{giiRegistracijaApi.subjektasApi.kodas + ' ' + giiRegistracijaApi.subjektasApi.pavadinimas }}</div>
            </div>
            <div class="row">
              <label class="label">
                {{ 'apskaita.registracijosData' | translate }}
              </label>
              <div>{{ giiRegistracijaApi.regData | date: 'yyyy-MM-dd' }}</div>
            </div>
            <div class="row">
              <label class="label">
                {{ 'apskaita.busena' | translate }}
              </label>
              <div>{{ 'label.busena.' + giiRegistracijaApi.busena | translate }}</div>
            </div>
            <div class="row">
              <div class="col-6">
                <label class="label">
                  {{ 'apskaita.perziura.tipas.' + giiRegistracijaApi.srautoKodas | translate }}
                </label>
              </div>
              <div class="col-6">
                <label class="label">
                  {{ 'ataskaita.kurimas.pradetaTiekti' | translate }}
                </label>
              </div>
            </div>
            <ng-container *ngFor="let srautas of giiRegistracijaApi.giiSrautasApiList; let firstItem = first">
              <div class="row">
                <div class="col-6">
                  <div>{{ srautas.pavadinimas | translateName }}</div>
                </div>
                <div class="col-6">
                  <div>{{ srautas.tiektaNuo | date: 'yyyy-MM-dd' || '-' }}</div>
                </div>
              </div>
            </ng-container>
          </div>
          <div class="col-3" *ngIf="data.busena == 'NEPRIIMTA'">
            <div class="row mb-2">
              <label class="label">
                <u>
                  {{ 'apskaita.tikrinimoDuomenys.title' | translate }}
                </u>
              </label>
            </div>
            <div class="row">
              <label class="label">
                {{ 'apskaita.tikrinimoDuomenys.atsakingasUzVertinima' | translate }}
              </label>
              <div>
                {{data.atsakingasVertinimas}}
              </div>
            </div>
            <div class="row">
              <label class="label">
                {{ 'apskaita.tikrinimoDuomenys.vertinimoData' | translate }}
              </label>
              <div>
                {{ nepriimtaAtaskVertinimas.vertinimoData | date: 'yyyy-MM-dd' }}
              </div>
            </div>
            <div class="row">
              <label class="label">
                {{ 'apskaita.tikrinimoDuomenys.vertinimoIsvada' | translate }}
              </label>
              <div>{{ 'apskaita.tikrinimoDuomenys.atmesti' | translate }}</div>
            </div>
            <div class="row">
              <label class="label">
                {{ 'apskaita.tikrinimoDuomenys.atmetimoPriezastys' | translate }}
              </label>
              <div>
                {{ nepriimtaAtaskVertinimas?.atmetimoPriezastis }}
              </div>
            </div>
            <div class="row">
              <label class="label">
                {{ 'apskaita.tikrinimoDuomenys.tikslinimoTerminas' | translate }}
              </label>
              <div>
                {{ nepriimtaAtaskVertinimas?.tikslinimoTerminas | date: 'yyyy-MM-dd' }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <kendo-grid [kendoGridBinding]="gridData" [groupable]="false" [group]="group">
        <kendo-grid-column [headerStyle]="{'font-size' : '14px'}" field="veiklosBudas" title="{{ ('apskaita.perziura.tipas.' + this.giiRegistracijaApi.srautoKodas) | translate }}">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.veiklosPavadinimas | translateName }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [headerStyle]="{'font-size' : '14px'}" field="impKiekis" title="{{ 'apskaita.perziura.impKiekisVnt' | translate }}"></kendo-grid-column>
        <kendo-grid-column [headerStyle]="{'font-size' : '14px'}" field="impSvoris" title="{{ 'apskaita.perziura.impKiekisTon' | translate }}"></kendo-grid-column>
        <kendo-grid-column [headerStyle]="{'font-size' : '14px'}" field="pagKiekis" title="{{ 'apskaita.perziura.pagKiekisVnt' | translate }}"></kendo-grid-column>
        <kendo-grid-column [headerStyle]="{'font-size' : '14px'}" field="pagSvoris" title="{{ 'apskaita.perziura.pagKiekisTon' | translate }}"></kendo-grid-column>
        <kendo-grid-column [headerStyle]="{'font-size' : '14px'}" field="visoKiekis" title="{{ 'apskaita.perziura.visoVnt' | translate }}"></kendo-grid-column>
        <kendo-grid-column [headerStyle]="{'font-size' : '14px'}" field="visoSvoris" title="{{ 'apskaita.perziura.visoTon' | translate }}"></kendo-grid-column>
        <kendo-grid-column [hidden]="true" [headerStyle]="{'font-size' : '14px'}" field="srautoId">
          <ng-template kendoGridGroupHeaderTemplate let-group="group">
            <div>{{ group.items[0].srautoPavadinimas | translateName }}</div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-messages
                [noRecords]="'label.sarasas.tuscias' | translate">
        </kendo-grid-messages>
      </kendo-grid>
    </div>
  `,
})
export class AtaskPerziuraComponent implements OnInit {
  @Input() data: GiiAtaskaitaApi = new GiiAtaskaitaApi();
  @Input() giiRegistracijaApi: GiiRegistracijaApi = new GiiRegistracijaApi();
  @Input() klasifikatoriusList: KlasifikatoriusApi[] = [];

  public gridData: AtaskVeiklosDuomenysApi[] = [];
  public group: GroupDescriptor[] = [{ field: "srautoId" }];
  public nepriimtaAtaskVertinimas = new GiiAtaskVertinimasApi();

  constructor(private languageService: LanguageService,
              public sharedDataService: SharedDataService) {
  }

  ngOnInit():void {
    if (this.data.busena == 'NEPRIIMTA') {
      this.nepriimtaAtaskVertinimas = this.data.giiAtaskVertinimasList.reduce((currentNewest, currentItem) => {
        return currentItem.vertinimoData > currentNewest.vertinimoData ? currentItem : currentNewest;
      }, this.data.giiAtaskVertinimasList[0]);
    }
    let ataskVeiklosList = this.data.giiAtaskVeiklosList;
    ataskVeiklosList.forEach(veikla => {
      if (veikla.veiklosDuomList) {
        veikla.veiklosDuomList.forEach(veiklosDuom => {
          let veikloDuomenys = new AtaskVeiklosDuomenysApi();
          veikloDuomenys.impKiekis = veiklosDuom.impKiekis;
          veikloDuomenys.impSvoris = veiklosDuom.impSvoris;
          veikloDuomenys.pagKiekis = veiklosDuom.pagKiekis;
          veikloDuomenys.pagSvoris = veiklosDuom.pagSvoris;
          veikloDuomenys.visoKiekis = (veiklosDuom.impKiekis !== null || veiklosDuom.pagKiekis !== null) ? (veiklosDuom.impKiekis + veiklosDuom.pagKiekis) : null;
          veikloDuomenys.visoSvoris = (veiklosDuom.impSvoris !== null || veiklosDuom.pagSvoris !== null) ? Math.round((veiklosDuom.impSvoris + veiklosDuom.pagSvoris) * 1e6) / 1e6 : null;
          veikloDuomenys.srautoId = veiklosDuom.srautoId;
          veikloDuomenys.veiklosPavadinimas = veiklosDuom.veiklosPavadinimas;
          veikloDuomenys.srautoPavadinimas = veiklosDuom.srautoPavadinimas;
          this.gridData.push(veikloDuomenys);
        })
      }
    })
  }
}

